// @ts-nocheck
(function () {
  function pad2(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function tick(root, targetSec) {
    var now = Math.floor(Date.now() / 1000);
    var d = targetSec - now;
    if (d <= 0) {
      window.location.reload();
      return;
    }
    var days = Math.floor(d / 86400);
    var hrs = Math.floor((d % 86400) / 3600);
    var mins = Math.floor((d % 3600) / 60);
    var secs = d % 60;

    var elDays = root.querySelector('[data-cd-days]');
    var elHrs = root.querySelector('[data-cd-hours]');
    var elMins = root.querySelector('[data-cd-mins]');
    var elSecs = root.querySelector('[data-cd-secs]');
    if (elDays) elDays.textContent = days > 999 ? '999+' : String(days);
    if (elHrs) elHrs.textContent = pad2(hrs);
    if (elMins) elMins.textContent = pad2(mins);
    if (elSecs) elSecs.textContent = pad2(secs);
  }

  function init(root) {
    if (root.dataset.capsuleCountdownInit) return;
    root.dataset.capsuleCountdownInit = 'true';
    var raw = root.getAttribute('data-capsule-countdown-target');
    var targetSec = parseInt(raw, 10);
    if (!targetSec || Number.isNaN(targetSec)) return;

    function run() {
      tick(root, targetSec);
    }
    run();
    window.setInterval(run, 1000);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-capsule-countdown]').forEach(function (el) {
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();